'use client';

import { IconCross } from '@picsart/design-system/foundation/icons/IconCross';

import { PULSE_NAMES } from '@/constants/pulseNames';
import { TEST_IDS } from './constants/testIds';
import useAppBannerDismissed, { dismissAppBanner } from './useAppBannerDismissed';
import useStyles from './styles';

/** The scheme both native GenAI apps (App Store and Google Play) register. */
const APP_URL = 'genai://open';

/**
 * Points mobile visitors at the native GenAI app. Shown on phones only (see
 * `styles`): on desktop there is no app for the scheme to open.
 */
const AppBanner = () => {
  const classes = useStyles();
  const isDismissed = useAppBannerDismissed();

  if (isDismissed) return null;

  return (
    <aside className={classes.banner} aria-label="GenAi Studio app" data-testid={TEST_IDS.CONTAINER} data-pulse-section="app-banner">
      <span className={classes.text}>Create AI effects in the app</span>
      <a href={APP_URL} className={classes.open} data-testid={TEST_IDS.OPEN_LINK} data-pulse-name={PULSE_NAMES.APP_BANNER_OPEN}>
        Open
      </a>
      <button type="button" onClick={dismissAppBanner} className={classes.close} aria-label="Close" data-testid={TEST_IDS.CLOSE_BUTTON} data-pulse-name={PULSE_NAMES.APP_BANNER_CLOSE}>
        <IconCross className={classes.closeIcon} aria-hidden="true" />
      </button>
    </aside>
  );
};

export default AppBanner;
